/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import { createSelector } from 'reselect';
import { hasAllBranding } from '../entities/branding/selectors';
import { getEntityData, findEntity, getEntityList } from '../entities/selectors';
import { userHasPermissions } from '../entities/selectors';

const getUserData = (state) => state.get('UserData');

export const getCurrentTenantName = (state) => state.get('UserData').get('currentTenantName');

export const currentTenantId = (state) => state.getIn(['UserData', 'currentTenantId']);

export const userIsAuthed = (state) => state.get('UserData').get('userIsAuthed');

export const getUserName = (state) => {
  if (state.get('UserData')) {
    return state.get('UserData').get('userName');
  }
};

export const getUserEmail = (state) => {
  if (state.get('UserData')) {
    return state.get('UserData').get('userEmail');
  }
};

export const platformViewOnlyMode = (state) => state.get('UserData').get('platformViewOnlyMode');

export const availableTenants = (state) => state.get('UserData').get('tenants');

export const getAvailableTenants = createSelector([availableTenants], (availableTenants) => availableTenants.toJS());

export const getAccountTenants = (state) => state.get('UserData').get('accountTenants');

export const getContactLayoutsExt = (state) => state.get('UserData').get('contactLayoutsExt');

export const getTenantsList = (state) => state.get('UserData').get('tenantsList');

export const getUsermenuPermission = (state) => {
  var permission = {};

  let entities = getEntityList(state).toJS();
  let listEntities = Object.keys(entities);
  var entitiesMapping = {}

  //Collect the Permission of Read/Create/Update rights.
 // listEntities.map(entity => {
  //  if (entity == 'users') {
      entitiesMapping['users'] = [];
      if (entities['users'].readPermission) {
        entitiesMapping['users'].push(...entities['users'].readPermission)
      }
      if (entities['users'].createPermission) {
        entitiesMapping['users'].push(...entities['users'].createPermission)
      }
      if (entities['users'].updatePermission) {
        entitiesMapping['users'].push(...entities['users'].updatePermission)
      }
 //   }
 // });

  //Check actually if the permission is assigned to this role or not.
 // for (var i = 0; i < listEntities.length; i++) {
    permission= userHasPermissions(state, entitiesMapping['users']);
    return permission;
 //}
}

export const getCurrentAgentId = (state) => state.get('UserData').get('agentId');

export const getCurrentTenantId = (state) => state.get('UserData').get('currentTenantId');

export const getAgentTenantRoleId = (state) => state.get('UserData').get('tenantRoleId');

export const getSdkLoaded = (state) => state.get('UserData').get('sdkLoaded');

export const getCurrentPermissions = createSelector([getUserData], function(userData) {
  let tenantPermissions = userData.get('permissions') || [];
  let platformPermissions = userData.get('platformPermissions') || [];

  if (!(tenantPermissions instanceof Array)) {
    tenantPermissions = Array.from(tenantPermissions);
  }
  if (!(platformPermissions instanceof Array)) {
    platformPermissions = Array.from(platformPermissions);
  }

  return tenantPermissions.concat(platformPermissions);
});

export const authenticatedAndBrandingReady = (state) => hasAllBranding(state) && userIsAuthed(state);

export const isTenantSetForReadAllMode = (state) =>
  availableTenants(state).find((tenant) => tenant.get('tenantId') === getCurrentTenantId(state)) === undefined;

export const getCurrentTenant = createSelector(
  [getCurrentTenantId, availableTenants], (currentTenantId, tenants) => {
    return tenants &&
    tenants.size > 0 &&
    tenants.find((tenant) => tenant.get('tenantId') === currentTenantId).toJS();
  }
);

export const getCurrentTenantTimezone = createSelector(
  [getCurrentTenantId, (state) => getEntityData(state, 'tenants')],
  (currentTenantId, tenants) =>
    tenants &&
    tenants.size > 0 &&
    tenants.find((tenant) => tenant.get('id') === currentTenantId) &&
    tenants.find((tenant) => tenant.get('id') === currentTenantId).get('timezone')
);

export const getCurrentAgentName = (state) => {
  const currentAgent = findEntity(state, 'users', getCurrentAgentId(state));
  return currentAgent && currentAgent.get('firstName');
};

export const getCurrentAgentFullName = (state) => {
  const currentAgent = findEntity(state, 'users', getCurrentAgentId(state));
  return currentAgent && (currentAgent.get('firstName') + ' ' + currentAgent.get('lastName'));
};

export const isCurrentTenantPlatformAuthenticationDisabled = createSelector(
  [getCurrentTenantId, state => getEntityData(state, 'tenants')],
  (currentTenantId, tenants) =>
    tenants &&
    tenants.size > 0 &&
    tenants.find(tenant => tenant.get('id') === currentTenantId) &&
    tenants.find(tenant => tenant.get('id') === currentTenantId).get('cxengageIdentityProvider') === 'disabled'
);
